import { makeObservable, runInAction, observable } from "mobx";
import { RootStore } from "./RootStore";
import { TransportService } from "../services/TransportService";
import DataStore from "./DataStore";
import { FormSaveRequest, FormsGetResponse } from "../models/Form";

const GET_FORMS_URL = "/forms?formIds=1000034,1000021,1000050,1000053";

class FormStore extends DataStore {
  rootStore: RootStore;
  forms: FormsGetResponse | undefined = undefined;

  constructor(transportService: TransportService, rootStore: RootStore) {
    super(transportService);
    this.rootStore = rootStore;

    makeObservable(this, {
      forms: observable,
      success: observable,
      error: observable
    });
  }

  setForms(forms: FormsGetResponse | undefined) {
    runInAction(() => {
      this.forms = forms ?? [];
    });
  }

  saveForm = async (formSaveRequest: FormSaveRequest) => {
    const token = await this.rootStore.keycloakStore.getRefreshedToken();
    if (!token) {
      return;
    }
    try {
      this.clearError("saveForm");
      this.setLoading("saveForm");
      await this.transportService.postWithToken(
        formSaveRequest,
        "/forms",
        token
      );
      this.setSuccess("saveForm");
      this.getForms();
    } catch (e) {
      console.error(e);
      this.setError("saveForm");
      return;
    } finally {
      this.clearLoading("saveForm");
    }
  };

  updateForm = async (formId: number, formSaveRequest: FormSaveRequest) => {
    const token = await this.rootStore.keycloakStore.getRefreshedToken();
    if (!token) {
      return;
    }
    try {
      this.clearError("updateForm");
      this.setLoading("updateForm");
      await this.transportService.putWithToken(
        formSaveRequest,
        `/forms/${formId}`,
        token
      );
      this.setSuccess("updateForm");
      this.getForms();
    } catch (e) {
      console.error(e);
      this.setError("updateForm");
      return;
    } finally {
      this.clearLoading("updateForm");
    }
  };

  getForms = async () => {
    const token = await this.rootStore.keycloakStore.getRefreshedToken();
    if (!token) {
      return;
    }
    try {
      this.clearError("getForms");
      this.setLoading("getForms");
      const res = await this.transportService.getWithToken(
        GET_FORMS_URL,
        token
      );
      this.setForms(res.data.forms as FormsGetResponse);
    } catch (e) {
      console.error(e);
      this.setError("getForms");
      return;
    } finally {
      this.clearLoading("getForms");
    }
  };

  getFormsByFormId = async (fieldGroupId: number) => {
    if (!this.forms) {
      await this.getForms();
    }
    return this.forms?.filter((a) => a.formId === fieldGroupId);
  };

  /*
  getForm = async (formId: number) => {
    const { clientId, token } = await this.rootStore.clientStore.getAuth();
    if (!clientId || !token) {
      return null;
    }

    try {
      this.clearError("getForm");
      this.setLoading("getForm");
      const res = await this.transportService.getWithToken(
        `/forms/${formId}`,
        token
      );
      console.log(res);
    } catch (e) {
      console.error(e);
      this.setError("getForm");
      return;
    } finally {
      this.clearLoading("getForm");
    }
  };
  */
}

export default FormStore;
